define(function (require, exports, module) {
    'use strict';

    const config = require('Cloud/config');
    const escapeForRegExp = require('../string/escapeForRegExp');
    const getStringLengthInBytes = require('../string/getStringLengthInBytes');
    const UploadReason = require('../../UploadReason');
    const InvalidCharactesFail = require('../../fails/InvalidCharactesFail');
    const NameTooLongFail = require('../../fails/NameTooLongFail');
    const PathTooLongFail = require('../../fails/PathTooLongFail');

    const MAX_NAME_LENGTH = config.get('ITEM_NAME_MAX_LENGTH');
    const MAX_PATH_LENGTH = 1024; // TODO: add to config
    const INVALID_NAME_CHARACTERS = config.get('ITEM_NAME_INVALID_CHARACTERS');
    const INVALID_PATH_CHARACTERS = config.get('ITEM_PATH_INVALID_CHARACTERS');

    /**
     * @namespace
     */
    const cloudFileSystemPath = {
        /**
         * Bytes
         * @type {number}
         */
        MAX_NAME_LENGTH: MAX_NAME_LENGTH,

        /**
         * Bytes
         * @type {number}
         */
        MAX_PATH_LENGTH: MAX_PATH_LENGTH,

        /**
         * @type {string}
         */
        INVALID_NAME_CHARACTERS: INVALID_NAME_CHARACTERS,

        /**
         * @type {string}
         */
        INVALID_PATH_CHARACTERS: INVALID_PATH_CHARACTERS,

        /**
         * @type {RegExp}
         */
        invalidNameCharacters: new RegExp('[' + escapeForRegExp(INVALID_NAME_CHARACTERS) + ']'),

        invalidNameCharactersGlobal: new RegExp('[' + escapeForRegExp(INVALID_NAME_CHARACTERS) + ']', 'g'),

        /**
         * @type {RegExp}
         */
        invalidPathCharacters: new RegExp('[' + escapeForRegExp(INVALID_PATH_CHARACTERS) + ']'),

        invalidPathCharactersGlobal: new RegExp('[' + escapeForRegExp(INVALID_PATH_CHARACTERS) + ']', 'g'),

        /**
         * @param {string} name
         * @return {boolean}
         */
        hasInvalidNameLength: function (name) {
            let hasInvalidNameLength = MAX_NAME_LENGTH < name.length;

            if (!hasInvalidNameLength) {
                const bytes = getStringLengthInBytes(name);

                hasInvalidNameLength = MAX_NAME_LENGTH < bytes;
            }

            return hasInvalidNameLength;
        },

        /**
         * @param {string} path
         * @return {boolean}
         */
        hasInvalidPathLength: function (path) {
            let hasInvalidPathLength = MAX_PATH_LENGTH < path.length;

            if (!hasInvalidPathLength) {
                const bytes = getStringLengthInBytes(path);

                hasInvalidPathLength = MAX_PATH_LENGTH < bytes;
            }

            return hasInvalidPathLength;
        },

        /**
         * @param {string} path
         * @return {boolean}
         */
        hasInvalidNameCharacters: function (path) {
            return cloudFileSystemPath.invalidNameCharacters.test(path);
        },

        /**
         * @param {string} path
         * @return {boolean}
         */
        hasInvalidPathCharacters: function (path) {
            return cloudFileSystemPath.invalidPathCharacters.test(path);
        },

        /**
         * @param {string} name
         * @return {boolean}
         */
        hasInvalidPattern: function (name) {
            // Имя файла или папки не может состоять
            // только из точки «.» или из двух точек «..»
            return name === '.' || name === '..';
        },

        /**
         * @param {string} path
         * @return {string}
         */
        removeInvalidNameCharacters: function (path) {
            return path.replaceAll(cloudFileSystemPath.invalidNameCharactersGlobal, '_');
        },

        /**
         * @param {string} path
         * @return {string}
         */
        removeInvalidPathCharacters: function (path) {
            return path.replaceAll(cloudFileSystemPath.invalidPathCharactersGlobal, '_');
        },

        /**
         * @param {string} name
         * @return {boolean|UploadReason}
         */
        validateName: function (name) {
            const source = UploadReason.SOURCE_WEB_CLIENT;
            let stack;
            let isInvalidName = cloudFileSystemPath.hasInvalidPattern(name);
            let result = true;

            if (isInvalidName) {
                stack = new Error('InvalidCharactesFail');
                result = new InvalidCharactesFail(stack, source);
            } else {
                isInvalidName = cloudFileSystemPath.hasInvalidNameCharacters(name);

                if (isInvalidName) {
                    stack = new Error('InvalidCharactesFail');
                    result = new InvalidCharactesFail(stack, source);
                } else {
                    isInvalidName = cloudFileSystemPath.hasInvalidNameLength(name);

                    if (isInvalidName) {
                        stack = new Error('NameTooLongFail');
                        result = new NameTooLongFail(stack, source);
                    }
                }
            }

            return result;
        },

        /**
         * @param {string} path
         * @return {boolean|UploadReason}
         */
        validatePath: function (path) {
            const source = UploadReason.SOURCE_WEB_CLIENT;
            let stack;
            let isInvalidPath = cloudFileSystemPath.hasInvalidPattern(path);
            let result = true;

            if (isInvalidPath) {
                stack = new Error('InvalidCharactesFail');
                result = new InvalidCharactesFail(stack, source);
            } else {
                isInvalidPath = cloudFileSystemPath.hasInvalidPathCharacters(path);

                if (isInvalidPath) {
                    stack = new Error('InvalidCharactesFail');
                    result = new InvalidCharactesFail(stack, source);
                } else {
                    isInvalidPath = cloudFileSystemPath.hasInvalidPathLength(path);

                    if (isInvalidPath) {
                        stack = new Error('PathTooLongFail');
                        result = new PathTooLongFail(stack, source);
                    }
                }
            }

            return result;
        },
    };

    module.exports = cloudFileSystemPath;
});
